"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
require("./AllCardsView.css");
var Paper_1 = __importDefault(require("@material-ui/core/es/Paper/Paper"));
var Typography_1 = __importDefault(require("@material-ui/core/es/Typography/Typography"));
var SelectedCardsView = /** @class */ (function (_super) {
    __extends(SelectedCardsView, _super);
    function SelectedCardsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectedCardsView.prototype.render = function () {
        var store = this.props.characterDataStore;
        return (react_1.default.createElement(Paper_1.default, { style: { marginTop: "1rem" } },
            react_1.default.createElement(Typography_1.default, { variant: "h6" }, "Card count: " + store.selectedCards.length + " / " + (store.currentCharacter && store.currentCharacter.numOfCards)),
            store.selectedCards.length === 0 && react_1.default.createElement(Typography_1.default, null, "No Cards Selected"),
            store.selectedCards.map(function (card) { return (react_1.default.createElement("img", { src: card.imgUrl, key: card.name, alt: card.name, onClick: function () { return store.toggleToFromScenarioDeck(card); }, style: { display: "inline", width: "12rem" } })); })));
    };
    SelectedCardsView = __decorate([
        mobx_react_1.inject("characterDataStore"),
        mobx_react_1.observer
    ], SelectedCardsView);
    return SelectedCardsView;
}(react_1.Component));
exports.default = SelectedCardsView;



//////////////////
// WEBPACK FOOTER
// ./src/components/SelectedCardsView.tsx
// module id = 6027
// module chunks = 0